.page-separator{margin:0 2px!important}img.world-map{height:auto;width:65%}.hide-message{padding:0 30px;width:100%}.hide-message a{color:#999}.hide-message a:hover{text-decoration:none;color:#222}
/*# sourceMappingURL=due-dates-widget.component-5L35K2TV.css.map */
